/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

// components
import { Checkbox, Grid } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';
// assets
import { WrapperCheckboxs } from '../../../assets/styles/styles';

const CardTermsAndConditions = (props) => {
  const { termsAndConditions, disabled, onChange } = props;

  return (
    <SimpleCard
      contentHeader={
        <article className="d-flex flex-column">
          <h2 className="text-color-38">Términos y condiciones de los contratos</h2>
        </article>
      }
      disabled={disabled}
    >
      <Grid className="m-0 padding-16 p-md-6">
        <p className="font-size-14 line-height-22 mb-2">
          Acepto los términos y condiciones establecidos en los contratos y declaro haberlos leído.
          Al ingresar alguno de los métodos de verificación dispuestos por Coopeuch, estaré firmando
          de manera electrónica, de acuerdo a la ley Nº19.799.
        </p>
        <WrapperCheckboxs>
          <Checkbox
            id="4111"
            label="Sí, acepto y declaro haberlos leído."
            checked={termsAndConditions.value}
            onChange={(e) =>
              onChange({
                field: 'termsAndConditions',
                property: 'value',
                value: e,
              })
            }
          />
        </WrapperCheckboxs>
      </Grid>
    </SimpleCard>
  );
};

CardTermsAndConditions.defaultProps = {
  termsAndConditions: { isValid: () => true, errors: [], value: false },
  onChange: () => null,
};
CardTermsAndConditions.propTypes = {
  termsAndConditions: PropTypes.shape({
    isValid: PropTypes.func,
    errors: PropTypes.array,
    value: PropTypes.bool,
  }),
  onChange: PropTypes.func,
};

export default CardTermsAndConditions;
